export enum queryKeys {
  clientEwalletBalances = 'clientEwalletBalances',
  ewalletsBalances = 'ewalletsBalances',
  loginData = 'loginData',
  listData = 'listData',
  listFilters = 'listFilter',
  currencyRates = 'currencyRates',
  userInfo = 'userInfo',
  nextBatchListData = 'nextBatchListData',
  ewalletContacts = 'ewalletContacts',
  ewalletDetails = 'ewalletDetails',
  ewalletThresholds = 'ewalletThresholds',
  ewalletTransactions = 'ewalletTransactions',
  settlementCurrencies = 'settlementCurrencies',
  virtualIbanCountries = 'virtualIbanCountries',
  merchantBankAccounts = 'merchantBankAccounts',
  identityDocs = 'identityDocs',
  settlementRequiredFields = 'settlementRequiredFields',
  settlementEwallets = 'settlementEwallets',
  merchantSignupCountries = 'merchantSignupCountries',
  ibanInfo = 'ibanInfo',
  settlementHistory = 'settlementHistory',
  settlementPayments = 'settlementPayments',
  signUpCountries = 'signUpCountries',
  virtualTerminalPaymentMethods = 'virtualTerminalPaymentMethods',
  rbaSupportedCurrencies = 'rbaSupportedCurrencies',
  paymentRequiredFields = 'paymentRequiredFields',
  apiAccessKey = 'apiAccessKey',
  supportedPaymentCategories = 'supportedPaymentCategories',
  getCheckoutConfig = 'getCheckoutConfig',
  supportedLanguagesCheckout = 'supportedLanguagesCheckout',
  paymentDetails = 'paymentDetails',
  dailyRate = 'dailyRate',
  balanceOverview = 'balanceOverview',
  refundDetails = 'refundDetails',
  disputedDetails = 'disputeDetails',
  listElementSearch = 'listElementSearch',
  customerDetails = 'customerDetails',
  calculateCurrencyRate = 'calculateCurrencyRate',
  protectElements = 'protectElements',
  protectListFingerprint = 'protectListFingerprint',
  getReusablePaymentLink = 'getReusablePaymentLink',
  payoutDetails = 'payoutDetails',
  senderDetails = 'senderDetails',
  beneficiaryDetails = 'beneficiaryDetails',
  payoutRequiredFields = 'payoutRequiredFields',
  payoutMethodTypes = 'payoutMethodTypes',
  getDefaultSender = 'getDefaultSender',
  getSupportedBeneficiaryCountries = 'getSupportedBeneficiaryCountries',
  getCardHostedPage = 'getCardHostedPage',
  getCorporateCards = 'getCorporateCards',
  getOneTimePaymentLink = 'getOneTimePaymentLink',
  underReviewPaymentDetails = 'underReviewPaymentDetails',
  getAccountProgress = 'getAccountProgress',
  mfaPreference = 'mfaPreference',
  verifyEmail = 'verifyEmail',
}

export enum mutationKeys {
  updateUserSettings = 'updateUserSettings',
  getPayoutSendersList = 'getPayoutSendersList',
  getPayoutBeneficiariesList = 'getPayoutBeneficiariesList',
  createSender = 'createSender',
  createBeneficiary = 'createBeneficiary',
  createPayout = 'createPayout',
  createPayoutDraft = 'createPayoutDraft',
}

export const defaultListLimit = 1000;
